'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'car-rear';
var width = 512;
var height = 512;
var aliases = ["car-alt"];
var unicode = 'f5de';
var svgPathData = 'M159.6 64l192.8 0c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6L96 192c-3.6 0-7.2 .2-10.7 .6l28.3-94.4c6.1-20.3 24.8-34.2 46-34.2zM74.7 227.9l.1-.3c6.6-2.3 13.8-3.6 21.2-3.6l320 0c7.4 0 14.5 1.3 21.2 3.6l.1 .3 .5-.1c24.6 8.9 42.3 32.5 42.3 60.2l-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 32c0 17.7-14.3 32-32 32l-96 0 0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 32-96 0c-17.7 0-32-14.3-32-32l0-32 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0c0-27.7 17.6-51.3 42.3-60.2l.5 .1zM320 384l-128 0 0-32 128 0 0 32zM48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288l0 64c0 23.7 12.9 44.4 32 55.4L32 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 384 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-56.6c19.1-11.1 32-31.7 32-55.4l0-64c0-35.7-19.4-66.8-48.3-83.3l-.4-1.3L429 89c-10.2-33.8-41.3-57-76.6-57L159.6 32C124.3 32 93.1 55.2 83 89L48.7 203.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCarRear = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;